import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Image } from "react-bootstrap";
import AWS from "aws-sdk";
import { uploadS3Data } from "../../constant/config";
const CreateCommunityGroupModal = ({
  show,
  onHide,
  onSubmit,
  editRoom,
  setEditRoom,
  from,
}) => {
  const [formData, setFormData] = useState({
    name: "",
    image: "",
    description: "",
  });

  const [imagePreview, setImagePreview] = useState(null);

  // ✅ Load editRoom data only when it's defined
  useEffect(() => {
    if (editRoom) {
      setFormData({
        name: editRoom?.name || "",
        image: editRoom?.image || "",
        description: editRoom?.description || "",
      });
      setImagePreview(editRoom?.image || null);
    }
  }, [editRoom]);

  // ✅ Handle text input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ Handle file uploads with preview + S3 URL
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setImagePreview(previewUrl);

      try {
        const imgUrl = await uploadS3Data(file, "profile_images");
        console.log("Uploaded Image URL:", imgUrl);

        setFormData((prev) => ({
          ...prev,
          image: imgUrl, // Save the actual S3 URL
        }));
      } catch (error) {
        console.error("Upload error:", error);
      }
    }
  };

  // ✅ Submit form
  const handleSubmit = (e) => {
    e.preventDefault();

    const dataToSend = {
      name: formData.name.trim(),
      image: formData.image, // Always send S3 URL
      description: formData.description.trim(),
    };

    onSubmit(dataToSend);
    onHide();

    // Reset after submit
    setFormData({ name: "", image: "", description: "" });
    setImagePreview(null);
  };

  return (
    <Modal
      show={show}
      onHide={() => {
        onHide();
        setEditRoom({
          id: "",
          name: "",
          description: "",
          image: "",
          status: null,
        });
      }}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {editRoom?.id ? "Edit" : "Create"}{" "}
          {from == "prayer_room" ? "Prayer " : "Community "} Group
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              placeholder="Enter group name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label className="fw-semibold">Upload Image</Form.Label>
            <div className="border border-2 rounded-3 p-4 text-center position-relative bg-light shadow-sm">
              <Form.Control
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                id="upload-image"
                style={{ display: "none" }}
              />
              <label
                htmlFor="upload-image"
                className="btn btn-outline-primary px-4 py-2"
                style={{ cursor: "pointer" }}
              >
                {imagePreview ? "Change Image" : "Select Image"}
              </label>

              {imagePreview && (
                <div className="mt-3 d-flex justify-content-center">
                  <Image
                    src={imagePreview}
                    alt="Preview"
                    rounded
                    style={{
                      maxHeight: "100px",
                      borderRadius: "12px",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                    }}
                  />
                </div>
              )}
            </div>
          </Form.Group>

          <Form.Group>
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="description"
              placeholder="Enter description"
              value={formData.description}
              onChange={handleChange}
              required
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button type="submit" variant="primary">
            Create
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CreateCommunityGroupModal;
